<template>
  <section class="shell">
    <h-header></h-header>
    <div class="shell-content">
      <h-messages v-if="navigation.path === '/'"></h-messages>
      <h-message v-if="navigation.path === 'message'" :id="navigation.params.id"></h-message>
    </div>
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Messages from './messages/List';
import Message from './messages/Message';
import Header from './Header';

import { applyToCompose } from './../utils/office';

export default {
  components: {
    'h-messages': Messages,
    'h-message': Message,
    'h-header': Header
  },
  data() {
    return {
      templateId: null
    };
  },
  computed: {
    ...mapState({
      navigation: s => s.navigation
    })
  }
};
</script>

<style scoped lang="scss">
.shell {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .shell-content {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    flex: 1;
    overflow: hidden;
    padding-top: 0.5rem;
    position: relative;
  }
}
</style>
